export const variables = {
    baseUrl: 'https://panel.copleydentalforms.com'
}
